import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import FrameDetails from 'features/Frames/components/FrameDetails/FrameDetails';
import { Frame, initialFrameState } from 'features/Frames/types';
import MonetisationHealthContainer from 'features/Health/containers/MonetisationHealthContainer';
import useFetchWithToken from 'hooks/useFetchWithToken';
import { FRAMES_API_URL } from 'utils/environmentVariables';

import useStyles from './FrameDetailsPage.styles';

type FrameParams = {
  frameId: string;
};

const FrameDetailsPage = () => {
  const classes = useStyles();
  const { frameId } = useParams<FrameParams>();
  const url = `${FRAMES_API_URL}/${frameId}`;
  const [frame, setFrame] = useState<Frame>(initialFrameState);
  const { fetchDataWithToken } = useFetchWithToken();

  useEffect(() => {
    fetchDataWithToken<Frame>(url, (data) => setFrame(data));
  }, [url]);

  return (
    <main className={classes.root}>
      <FrameDetails currentFrame={frame} />
      <MonetisationHealthContainer frame={frame} />
    </main>
  );
};

export default FrameDetailsPage;
